const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCartebleue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "card_cardbleue",
    transform: "matrix(0.5,0,0,0.5,0,10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-11",
    d: "M120,8C120,3.585 116.415,0 112,0L8,0C3.585,0 0,3.585 0,8L0,72C0,76.415 3.585,80 8,80L112,80C116.415,80 120,76.415 120,72L120,8Z",
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "matrix(1,0,0,1,14,20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M24.04,18.729L48.166,18.729C47.951,13.974 46.736,9.071 43.051,5.921C38.661,2.169 30.972,0.778 24.101,0.778C16.95,0.778 9.042,2.304 4.629,6.329C0.824,9.797 0.001,15.376 0.001,20.388C0.001,25.639 1.611,31.746 5.739,35.266C10.128,39.007 17.242,40.001 24.101,40.001C30.765,40.001 37.984,38.879 42.348,35.325C46.7,31.776 48.204,25.797 48.204,20.388L48.204,20.363L24.04,20.363L24.04,18.729Z",
    style: {
      fill: "rgb(254,254,254)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M49.709,20.397L49.709,39.223L83.231,39.223L83.231,39.198C88.137,38.953 92.039,34.901 92.039,29.925C92.039,24.948 88.137,20.636 83.231,20.388L83.231,20.397L49.709,20.397Z",
    style: {
      fill: "rgb(254,254,254)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M91.456,10.197C91.456,5.396 87.659,1.592 82.874,1.592C82.543,1.592 82.136,1.528 81.816,1.564L49.709,1.564L49.709,18.835L83.532,18.835C87.969,18.452 91.456,14.741 91.456,10.197",
    style: {
      fill: "rgb(254,254,254)"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(4.898e-15,79.9904,-79.9904,4.898e-15,60,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(40,58,126)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "rgb(71,144,206)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "rgb(71,144,206)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(51,117,87)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(51,117,87)",
      stopOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartebleue);
export default __webpack_public_path__ + "static/media/cartebleue.1a02b2ac7c23ebd25af6b9f5e2463f5c.svg";
export { ForwardRef as ReactComponent };